<template>
  <div class="card-custom">
    <div class="col-12 projects">
      <div class="flex-grow-1 p-0">
        <div class="col-12 d-flex">
          <div class="dropdown col-xl-4 col-lg-4 col-sm-2 col-xs-2 col-2">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-funnel-fill" viewBox="0 0 16 16">
                <path
                  d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z" />
              </svg>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <router-link class="dropdown-item" :to="{ name: 'dashboard' }">By Tracks</router-link>
              <router-link class="dropdown-item" :to="{ name: 'projects' }">By Projects</router-link>
            </div>
          </div>
          <div class="col-col-xl-4 col-lg-4 col-sm-5 col-xs-5 col-5 d-flex justify-content-center align-items-center">
            <TopDashboardBar />
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-4 col-xs-4 col-4 d-flex justify-content-lg-end align-items-lg-end">
            <LeftNav />
          </div>

        </div>

        <div class="">
          <div class="card-body-track mt-0 ml-0 p-0">
            <div class="d-flex flex-column mid-track-height pl-0" id="trackList" style="overflow: auto">
              <div class="d-flex flex-row mb-1 pb-2 border-white" style="border-bottom: 1px solid #fff">
                <div class="col-1"></div>
                <div @click="sortName" class="col-6 pl-0 card-accent-text sortHeader">
                  Name
                  <SortChevrons :name="apiEvents.nameSortDirection" :width="23" :height="23"></SortChevrons>
                </div>
                <div @click="sortDate"
                  class="col-0 col-sm-0 col-md-0 col-lg-2 col-xl-2 d-sm-none d-md-none d-none d-lg-block d-xl-block card-accent-text sortHeader">
                  Date
                  <SortChevrons :name="apiEvents.dateSortDirection" :width="23" :height="23"></SortChevrons>
                </div>
                <div @click="sortStatus"
                  class="col-1 d-sm-none d-xs-none d-md-none d-none d-lg-block d-xl-block card-accent-text sortHeader">
                  Status
                  <SortChevrons :name="apiEvents.statusSortDirection" :width="23" :height="23"></SortChevrons>
                </div>
                <div class="col-2"></div>
              </div>
              <div class="overflow-auto t-list">
                <div class="mr-2" v-for="track in apiEvents.userTracks" :key="track.id">
                  <trackItem class="trackText" :name="track.trackname" :id="track.id" :category="track.category"
                    :trackStyle="track.style" :mixid="track.mixids" :trackStatus="track.status"
                    :timestamp="track.timestamp" :reupload_request="track.reupload_req" :approved="track.approved" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TrackItem from "@/components/TrackItem.vue";
import SortChevrons from "@/components/SortChevrons.vue";
import TopDashboardBar from "@/components/TopDashboardBar.vue";
import LeftNav from "../components/LeftNav.vue";

export default {
  computed: {
    ...mapState(["apiEvents"]),
  },

  components: {
    TrackItem,
    SortChevrons,
    TopDashboardBar,
    LeftNav,
  },

  methods: {
    sortName() {
      this.$store.state.apiEvents.nameSortDirection;
      this.$store.dispatch("apiEvents/sortByName");
    },
    sortDate() {
      this.$store.dispatch("apiEvents/sortByDate");
    },
    sortStatus() {
      this.$store.dispatch("apiEvents/sortByStatus");
    },
  },
};
</script>

<style scoped>
.mid-track-height {
  height: calc(100vh - 250px);
  overflow: auto;
}

.trackText {
  color: #fff;
  font-size: 15px;
  font-family: "Open Sans";
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-top: 12px !important;
  margin-bottom: 5px !important;
}

.sortHeader {
  cursor: pointer;
}
</style>
